import { render } from "./BatchWizardContainer.vue?vue&type=template&id=f0ea8188"
import script from "./BatchWizardContainer.vue?vue&type=script&lang=js"
export * from "./BatchWizardContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__